import { jsx } from 'panel';
import { ModalEl, ModalType } from '../modal';
import { SvgIconEl } from '../svg-icon';
export function template() {
  const proxyAttrs = {
    closeable: this.attr("closeable"),
    open: this.attr("open"),
    'not-fullscreen': this.attr("not-fullscreen"),
    'modal-type': ModalType.Popup
  };
  return jsx(ModalEl, {
    attrs: proxyAttrs,
    on: {
      change: this.helpers.modalChanged
    }
  }, jsx("div", {
    sel: '.mp-alert-container'
  }, jsx("div", {
    sel: '.mp-alert-body'
  }, jsx("div", {
    sel: '.mp-alert-icon',
    class: {
      'large-icon': this.attr("large-icon")
    }
  }, jsx(SvgIconEl, {
    style: {
      color: this.attr("icon-color") || "#e4567b"
    },
    attrs: {
      icon: this.attr("icon") || "warning"
    }
  })), jsx("div", {
    sel: '.mp-alert-copy'
  }, jsx("slot", null)))));
}